<template>
<v-app style="background: rgba(0,0,0,0);">
        <Navbar />
        <router-view/>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
var Tabulator = require("tabulator-tables"); //import Tabulator library

export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>

<!--
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
-->



// WEBPACK FOOTER //
// src/App.vue